var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIndicator = function SvgIndicator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 12 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.265 1.367-3.69 6.392c-.355.614-.97.26-.615-.355l1.225-2.121a.01.01 0 0 0-.014-.015l-2.649.98C.863 6.576.45 7.25.456 7.986.464 8.993.81 10.533.95 11.12c.21.882.696 1.672 1.481 2.125l2.774 1.602c1.702.982 3.878.399 4.861-1.303l1.514-2.623c.549-.95.29-2.16-.6-2.803A258 258 0 0 0 7.335 5.52a.01.01 0 0 1-.003-.013L9.144 2.37A1.064 1.064 0 0 0 8.712.894c-.516-.269-1.156-.031-1.447.473"
  })));
};
export default SvgIndicator;